import Api from '@/services/Api'

export default {
    getAllNiifNoControlante(){
        return Api().get('getAllNiifNoControlante')
    },
    updateNiifNoControlante(infoData){
        return Api().put('updateNiifNoControlante',infoData)
    }
}